import { string, number, array, object } from '@gogame/schemas';
import { CHAT_ID, COMMENT, MESSAGE_ID, REASONS } from './constants';

export const FeedbackDialogSchema = object({
  [CHAT_ID]: number().required('Chat id is required'),
  [MESSAGE_ID]: number(),
  [COMMENT]: string().required('Comment is required'),
  [REASONS]: array(number()).required('Reasons is required'),
});
